import { motion } from 'framer-motion'
import Accordion from '../ui/Accordion'
import Button from '../ui/Button'

const FAQSection = () => {
  const faqs = [
    {
      question: 'O que diz a lei sobre o Controle de Ponto online?',
      answer: 'A Portaria 671 do Ministério do Trabalho regulamenta o controle de ponto eletrônico e permite o uso de sistemas online desde que atendam requisitos de segurança, autenticidade e inalterabilidade dos registros. O Flow Clock está 100% em conformidade com toda a legislação vigente.'
    },
    {
      question: 'Quantos funcionários para o Controle de Ponto ser obrigatório?',
      answer: 'De acordo com a CLT (Consolidação das Leis do Trabalho), empresas com mais de 20 funcionários são obrigadas a fazer o controle de ponto. No entanto, mesmo empresas menores podem se beneficiar de um sistema organizado de gestão de ponto.'
    },
    {
      question: 'O que acontece se o trabalhador esquecer de bater o ponto?',
      answer: 'O sistema permite que gestores ou o próprio colaborador façam ajustes posteriores mediante justificativa. Todos os ajustes ficam registrados no sistema com histórico completo para auditoria, garantindo transparência e conformidade legal.'
    },
    {
      question: 'Tem como exportar arquivos de registro de ponto?',
      answer: 'Sim! O Flow Clock permite exportar relatórios em diversos formatos (PDF, Excel, CSV) e oferece integração nativa com os principais sistemas de folha de pagamento do mercado, facilitando o processamento da folha.'
    },
    {
      question: 'Como funciona a folha de ponto digital?',
      answer: 'A folha de ponto digital registra automaticamente entradas, saídas, intervalos e horas extras dos colaboradores. O sistema calcula automaticamente banco de horas, feriados, DSR e gera relatórios completos prontos para integração com a folha de pagamento.'
    },
    {
      question: 'O sistema é seguro?',
      answer: 'Absolutamente! Utilizamos criptografia de ponta a ponta, armazenamento em nuvem com backup automático e estamos em total conformidade com a LGPD (Lei Geral de Proteção de Dados). Todos os dados são protegidos com os mais altos padrões de segurança da indústria.'
    },
    {
      question: 'Qual o tempo de implementação do sistema?',
      answer: 'A implementação é rápida e pode ser feita em até 48 horas após a contratação. Nossa equipe oferece treinamento completo e suporte durante todo o processo de onboarding para garantir uma transição suave.'
    },
    {
      question: 'O sistema funciona offline?',
      answer: 'O aplicativo mobile possui modo offline que armazena os registros localmente e sincroniza automaticamente quando a conexão com a internet é restabelecida, garantindo que nenhum registro seja perdido.'
    }
  ]

  return (
    <section id="faq" className="py-20 bg-gray-50 dark:bg-gray-950">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="inline-block px-4 py-2 rounded-full bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 text-sm font-semibold mb-4">
            Perguntas Frequentes
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            Tire suas dúvidas sobre o{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-primary-800">
              Flow Clock
            </span>
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Respondemos as principais questões sobre nosso sistema de controle de ponto
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="max-w-4xl mx-auto mb-12"
        >
          <Accordion items={faqs} allowMultiple={false} />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center bg-white dark:bg-gray-900 rounded-2xl p-12 max-w-3xl mx-auto shadow-sm"
        >
          <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
            Ainda tem dúvidas?
          </h3>
          <p className="text-xl text-gray-600 dark:text-gray-300 mb-6">
            Nossa equipe está pronta para ajudar!
          </p>
          <a href="#contato">
            <Button size="lg">
              Falar com Especialista
            </Button>
          </a>
        </motion.div>
      </div>
    </section>
  )
}

export default FAQSection
